
export default class GetContactPersonWorkOrdersRequest {    
    public pageNumber: number = 1;

    public pageSize: number = 100;
}